<div class="flex-control flex-column flex-height">
  <app-program-enrolled-header class="flex-header" *ngIf="program" [program]="program" [showVitals]="true"></app-program-enrolled-header>
  <app-program-wizard class="flex-body" [patient]="patient" [program]="program"></app-program-wizard>
</div>
